class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateInventoryStatus();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (!mediaGallery) return;

    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateInventoryStatus() {
    this.productInventoryNode = document.querySelector('[data-product-inventory]');

    if (!this.productInventoryNode || !window.inventories || !window.inventories[this.dataset.productId]) return;

    this.inventoryThreshold = parseInt(this.productInventoryNode.dataset.threshold);
    this.showQuantityInStock = this.productInventoryNode.dataset.showQuantityInStock;

    const variantInventoryObject = window.inventories[this.dataset.productId][this.currentVariant?.id];

    if (!this.currentVariant || !this.currentVariant.inventory_management || variantInventoryObject.policy === 'continue') {
      this.toggleInventoryQuantity(false);
      this.toggleIncomingInventory(false);

      return;
    }

    if (this.currentVariant.inventory_management === 'shopify') {
      if (variantInventoryObject.policy === 'continue') {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(false);
        
        return;
      }

      if (variantInventoryObject.quantity <= 0 && variantInventoryObject.incoming === 'true' && variantInventoryObject.quantity < this.inventoryThreshold) {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(true, variantInventoryObject.next_incoming_date);
      } else {
        this.toggleInventoryQuantity(true, variantInventoryObject.quantity);
        this.toggleIncomingInventory(false);
      }
    }
  }

  toggleInventoryQuantity(show, quantity) {
    if (show === false) {
      this.productInventoryNode.classList.add('hide');
      return;
    }

    if (this.currentVariant && this.currentVariant.available && parseInt(quantity) <= parseInt(this.inventoryThreshold)) {
      this.productInventoryNode.classList.add('inventory-status--low');
      this.productInventoryNode.classList.remove('inventory-status--sold-out');

      if (!this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left;
      }
        
      this.productInventoryNode.classList.remove('hide');
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) > parseInt(this.inventoryThreshold)) {
      this.productInventoryNode.classList.remove('inventory-status--low', 'inventory-status--sold-out');
      if (!this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock;
      }
      this.productInventoryNode.classList.remove('hide');
    } else {
      this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock;
      this.productInventoryNode.classList.add('inventory-status--sold-out');
      this.productInventoryNode.classList.remove('hide');
    }
  }

  toggleIncomingInventory(show, date) {
    const incomingInventoryNode = document.querySelector('[data-incoming-inventory]');
    if (!incomingInventoryNode) return;

    if (show == false && incomingInventoryNode) {
      incomingInventoryNode.classList.add('hide');

      return;
    }

    let string = !date ?
      window.variantStrings.inventory.waiting_for_stock : 
      window.variantStrings.inventory.will_be_in_stock_after.replace('[date]', date);

    incomingInventoryNode.classList.remove('hide');
    incomingInventoryNode.firstElementChild.textContent = string;
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

renderProductInfo() {
  fetch(
    `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
      this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
    }`
  )
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const sourceSection = this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section;

      const destination = document.getElementById(
        `price-${this.dataset.section}`
      );
      const source = html.getElementById(`price-${sourceSection}`);

      if (source && destination) {
        destination.innerHTML = source.innerHTML;
      }

      const badgesDestination = document.getElementById(
        `ProductBadges-${this.dataset.section}`
      );
      const badgesSource = html.getElementById(
        `ProductBadges-${sourceSection}`
      );

      if (badgesDestination && badgesSource) {
        badgesDestination.innerHTML = badgesSource.innerHTML;
        badgesDestination.hidden = badgesSource.hidden;
      }

      const price = document.getElementById(
        `price-${this.dataset.section}`
      );
      const sourceForm = html.getElementById(
        `product-form-${sourceSection}`
      );
      const sourceButton = sourceForm
        ? sourceForm.querySelector('[name="add"] > span')
        : null;
      const sourceButtonLabel = sourceButton
        ? sourceButton.textContent.trim()
        : '';

      if (price) price.classList.remove('hidden');

      this.toggleAddButton(
        !this.currentVariant.available,
        sourceButtonLabel
      );
    });
}

toggleAddButton(disable = true, text, modifyClass = true) {
  const productForm = document.getElementById(
    `product-form-${this.dataset.section}`
  );

  if (!productForm) return;

  const addButton = productForm.querySelector('[name="add"]');
  const addButtonText = productForm.querySelector(
    '[name="add"] > span'
  );

  if (!addButton || !addButtonText) return;

  if (!modifyClass) {
    addButton.setAttribute('disabled', 'disabled');
    return;
  }

  const notifyMode = disable === true;

  addButton.removeAttribute('disabled');
  addButton.removeAttribute('aria-disabled');
  addButton.dataset.productAvailable = notifyMode
    ? 'false'
    : 'true';

  if (notifyMode) {
    addButtonText.textContent =
      addButton.dataset.notifyLabel ||
      'Notify me when available';
  } else if (text) {
    addButtonText.textContent = text;
  } else if (this.dataset.isPreorder === 'true') {
    addButtonText.textContent = window.variantStrings.preOrder;
  } else {
    addButtonText.textContent = window.variantStrings.addToCart;
  }
}

setUnavailable() {
  const productForm = document.getElementById(
    `product-form-${this.dataset.section}`
  );

  if (!productForm) return;

  const addButton = productForm.querySelector('[name="add"]');
  const addButtonText = productForm.querySelector(
    '[name="add"] > span'
  );
  const price = document.getElementById(
    `price-${this.dataset.section}`
  );

  if (!addButton || !addButtonText) return;

  addButton.setAttribute('disabled', 'disabled');
  addButton.dataset.productAvailable = 'unavailable';
  addButtonText.textContent = window.variantStrings.unavailable;

  if (price) price.classList.add('hidden');
}

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-product-submit]');

  if (
    !button ||
    button.dataset.productAvailable !== 'false'
  ) {
    return;
  }

  event.preventDefault();

  const productForm = button.closest('form');
  const variantInput = productForm
    ? productForm.querySelector('input[name="id"]')
    : null;
  const omnisendFormId = (
    button.dataset.omnisendFormId || ''
  ).trim();

  if (variantInput && variantInput.value) {
    const variantUrl = new URL(window.location.href);
    variantUrl.searchParams.set(
      'variant',
      variantInput.value
    );

    window.history.replaceState(
      {},
      '',
      variantUrl.toString()
    );
  }

  if (!omnisendFormId) {
    console.error(
      'Omnisend back-in-stock form ID is missing.'
    );
    return;
  }

  window.omnisend = window.omnisend || [];
  window.omnisend.push([
    'openForm',
    omnisendFormId
  ]);
});

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    this.updateLegends();
  }

  updateLegends() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    fieldsets.forEach((fieldset) => {
      const legend = fieldset.querySelector('legend [data-variant-legend]');
      const selectedOption = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      legend.textContent = selectedOption.getAttribute('value');
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// Store product handles to history for "recently-viewed" section.
(function() {
  const history = sessionStorage.getItem('Woolman_Product_History') ? sessionStorage.getItem('Woolman_Product_History').split(',') : [];
  const productHandle = window.location.pathname.split('/').pop();
  if (!productHandle) return;
  if (!history.includes(productHandle)) {

    if (history.length >= 10) { // only store up to 10 recently viewed products
      history.shift();
    }
    
    history.push(productHandle);
    sessionStorage.setItem('Woolman_Product_History', history.join(','));
  }
})();

const Photoswipe = {
  attempts: 0,

  selectors: {
    images: '.photoswipe__image'
  },

  init: function() {
    document.querySelectorAll('.photoswipe__image').forEach(trigger => {
      trigger.addEventListener('click', this.downloadAndMount.bind(this));
    });
  },

  downloadAndMount: function(evt) {
    if (this.attempts >= 10) { return };
    this.attempts++;
    const existingScript = document.querySelector(`script[src="${theme.assets.photoswipe}"]`);

    // If we are already processing one slider, wait a while and try again.
    if (window.processingPhotoswipe) {
      setTimeout(this.downloadAndMount.bind(this), 200);
      return;
    }

    // Photoswipe script was already found in document, proceed to immediately mount slider
    if (existingScript) {
      this.showZoom(evt);
      return;
    }

    // Photoswipe script was not found in document, download it and wait for it to load, then show zoom
    window.processingPhotoswipe = true;

    const script = document.createElement('script');
    script.setAttribute('defer', 'true');
    script.setAttribute('async', 'true');
    script.src = theme.assets.photoswipe;
    document.body.append(script);

    script.addEventListener('load', () => {
      this.showZoom(evt)
    })
  },

  showZoom: function(evt) {
    const target = evt.currentTarget || evt.target;
    this.targetElement = target.closest('[data-photoswipe-parent]');
    this.items = this.getImageData();

    this.initGallery(this.items, target.dataset.index || 1);
    window.processingPhotoswipe = false;
  },

  getImageData: function() {
    this.images = this.targetElement.querySelectorAll(this.selectors.images)

    const items = [];
    
    this.images.forEach(el => {
      const item = {
        src: el.getAttribute('data-photoswipe-src'),
        w: parseInt(el.getAttribute('data-photoswipe-width')),
        h: parseInt(el.getAttribute('data-photoswipe-height')),
        initialZoomLevel: 0.5
      }

      items.push(item);
    });

    return items;
  },

  initGallery: function(items, index) {
    const pswpElement = document.querySelectorAll('.pswp')[0];

    const options = {
      allowPanToNext: false,
      captionEl: false,
      closeOnScroll: false,
      counterEl: false,
      history: false,
      index: parseInt(index) - 1,
      pinchToClose: false,
      preloaderEl: false,
      shareEl: false,
      tapToToggleControls: false
    }

    this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    this.gallery.init();
  }
};
Photoswipe.init()